// extracted by mini-css-extract-plugin
module.exports = {"title":"GenericPrivacyPage_title__34Tnx","paragraph":"GenericPrivacyPage_paragraph__3har0"};